"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class OfferMapper {
    toDomain(result) {
        const offer = lodash_1.default.get(result, "data.offer");
        const formulaItems = lodash_1.default.get(result, "data.formulaItems");
        return { offer };
    }
}
exports.OfferMapper = OfferMapper;
